import { render, staticRenderFns } from "./TenantCreate.vue?vue&type=template&id=63e33396&scoped=true&"
import script from "./TenantCreate.vue?vue&type=script&lang=js&"
export * from "./TenantCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e33396",
  null
  
)

export default component.exports